<script setup lang="ts">
import { settings } from '@/content'
</script>

<template>
  <section class="lbl">
    <div class="container lbl__in">
      <span class="lbl__intro">Entreprise artisanale reconnue, qualifiée et labellisée :</span>
      <ul class="lbl__list">
        <li v-for="l in settings.labels" :key="l">{{ l }}</li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
.lbl {
  background: #fff;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}
.lbl__in {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  padding-top: 24px;
  padding-bottom: 24px;
}
.lbl__intro {
  color: var(--muted);
  font-size: 0.9rem;
}
.lbl__list {
  display: flex;
  gap: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
}
.lbl__list li {
  border: 2px solid var(--green);
  color: var(--green-dark);
  font-family: var(--font-title);
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 8px 18px;
  border-radius: var(--radius-sm);
  font-size: 0.9rem;
}
</style>
